import { getCurrentCookieConsents } from "./services/cookie-consent-utils";
import sha256 from "sha256";

export function initializeGainsightPX(gainsightId) {
    if (gainsightId)
        // Gainsight PX Tag
        (function (n, t, a, e, x) {
            let i = "aptrinsic";
            // eslint-disable-next-line no-unused-expressions
            (n[i] =
                n[i] ||
                function () {
                    (n[i].q = n[i].q || []).push(arguments);
                    // eslint-disable-next-line no-sequences
                }),
                (n[i].p = e),
                (n[i].c = x);

            let r = t.createElement("script");
            r.async = !0;
            r.src = a + "?a=" + e;

            let c = t.getElementsByTagName("script")[0];
            c?.parentNode.insertBefore(r, c);
        })(
            window,
            document,
            "https://web-sdk.aptrinsic.com/api/aptrinsic.js",
            gainsightId, // Gainsight tag key
            { allowCrossDomain: true },
        );
    // End Gainsight PX Tag
}

export function identifyGainsightPX(params) {
    const { C0005: profilingCookiesAccepted } = getCurrentCookieConsents();
    const normalizeAndHash = (s) => s && sha256(s.toLowerCase().trim());

    console.log("identify", params);

    window?.aptrinsic?.(
        "identify",
        {
            id: normalizeAndHash(params?.user?.id),
            email: profilingCookiesAccepted ? params?.user?.email : "Email",
            firstName: profilingCookiesAccepted
                ? params?.user?.firstName
                : "FirstName",
            lastName: profilingCookiesAccepted
                ? params?.user?.lastName
                : "LastName",
            language: params?.settings?.language,
        },
        {
            id: normalizeAndHash(params?.item?.id),
            name: profilingCookiesAccepted ? params?.item?.description : "name",
            taxId: profilingCookiesAccepted ? params?.item?.taxId : "taxId",
            vatNumber: profilingCookiesAccepted
                ? params?.item?.vatNumber
                : "vatNumber",
            classifier: params?.item?.classifier,
            taxRegion: params?.item?.taxRegion,
        },
    );
}
